import React, { useEffect, useState } from 'react';
import { getContent } from '@/lib/api';

export const ClientsMarquee = ({ dark = true }) => {
  const [clients, setClients] = useState([]);
  useEffect(() => {
    getContent('clients').then(setClients).catch(() => {});
  }, []);
  if (!clients.length) return null;
  // Prefer clients with logos for the marquee; fall back to all if none.
  const withLogos = clients.filter((c) => c.logo);
  const base = withLogos.length ? withLogos : clients;
  const row = [...base, ...base];
  return (
    <div className='marquee relative w-full overflow-hidden py-2'>
      <div className='marquee-track'>
        {row.map((c, i) => (
          <div key={i} className='mx-6 flex shrink-0 items-center'>
            {c.logo ? (
              <span className='flex h-14 items-center rounded-lg bg-white/95 px-5 shadow-sm'>
                <img src={c.logo} alt={c.name} loading='lazy' className='max-h-9 w-auto object-contain' />
              </span>
            ) : (
              <span
                className={`font-head text-xl sm:text-2xl font-semibold tracking-tight transition-colors duration-300 ${
                  dark ? 'text-[#F6F5F1]/45 hover:text-[#F6F5F1]' : 'text-[#20272A]/40 hover:text-[#20272A]'
                }`}
              >
                {c.name}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
